import { createFileRoute, Outlet } from "@tanstack/react-router"

import { AppShell } from "@/components/layout/app-shell"
import { SettingsSidebar } from "@/components/layout/settings-sidebar"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/settings"
)({
  component: SettingsLayout,
})

function SettingsLayout() {
  return (
    <AppShell sidebar={<SettingsSidebar />}>
      <Outlet />
    </AppShell>
  )
}
